export default __webpack_public_path__ + "static/media/Artefact of the Faceless Sphinx.b71791f0.jpg";